export default {
  name: 'video-player-dialog',
  inject: [
    '$utils'
  ],
  props: {
    playVideo: {
      required: true
    }
  },
  computed: {
    player () {
      return this.playVideo
    }
  }
}
